import { createContext, useContext } from 'react';

type SegmentedControlValueContextValue = string;

const SegmentedControlValueContext = createContext<SegmentedControlValueContextValue | null>(null);

export const SegmentedControlValueProvider = SegmentedControlValueContext.Provider;

export const useSegmentedControlValue = (): SegmentedControlValueContextValue => {
  const context = useContext(SegmentedControlValueContext);
  if (context === null) {
    throw new Error('useSegmentedControlValue must be used within a SegmentedControlValueProvider');
  }
  return context;
};
